import { render } from "./HomeFooterView.vue?vue&type=template&id=79d74cc2&scoped=true"
import script from "./HomeFooterView.vue?vue&type=script&lang=js"
export * from "./HomeFooterView.vue?vue&type=script&lang=js"

import "./HomeFooterView.vue?vue&type=style&index=0&id=79d74cc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d74cc2"]])

export default __exports__